import React from 'react';
import { Button, Col, Input } from 'reactstrap';
import { useHistory } from 'react-router-dom';

export const GlobalFilter = ({
  filter,
  setFilter,
  urlNewItem,
  disableButtomCreate,
  children,
}) => {
  let history = useHistory();

  const handleCreateNewItem = () => {
    history.push('/admin' + urlNewItem);
  };

  return (
    <Col lg='8'>
      <br />
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <Input
          className='w-100 form-control-alternative'
          placeholder='Pesquisar ...'
          type='text'
          value={filter || ''}
          onChange={(e) => setFilter(e.target.value)}
          style={{ fontSize: '18px' }}
        />
        {!disableButtomCreate && (
          <Button color='primary' onClick={handleCreateNewItem} size='sm'>
            Adicionar
          </Button>
        )}
        {children}
      </div>
    </Col>
  );
};
